import { BidFilter, InventoryManagementBidsFilter, InventoryManagementDealerFilter } from 'remarketing-angular-library';

export enum FilterSectionTypes {
  OFFERS = 'OFFERS',
  QUESTIONS = 'QUESTIONS',
  BIDS_OFFERS = 'BIDS_OFFERS',
  SHARED_LISTS = 'SHARED_LISTS',
  GROUNDED = 'GROUNDED'
}

export enum OfferFilters {
  NONE = 'NO_OFFER_FILTER',
  OFFERS_BY_ANY_DEALER = 'OFFERS_BY_ANY_DEALER',
  OFFERS_BY_DEALER = 'OFFERS_BY_DEALER',
  DEALERS_WITH_COUNTER_OFFERS = 'DEALERS_WITH_COUNTER_OFFERS'
}

export enum QuestionFilters {
  NONE = 'NO_QUESTION_FILTER',
  QUESTIONS_BY_ANY_DEALER = 'QUESTIONS_BY_ANY_DEALER',
  QUESTIONS_BY_DEALER = 'QUESTIONS_BY_DEALER'
}

export enum BidsOffersFilters {
  ALL = 'NO_BIDS_OFFERS_FILTER',
  WINNING_BIDS_OFFERS = 'WINNING_BIDS_OFFERS',
  LOSING_BIDS_OFFERS = 'LOSING_BIDS_OFFERS'
}

export enum GroundedFilters {
  ALL = 'NO_GROUNDED_FILTER',
  GROUNDED = 'GROUNDED',
  NOT_GROUNDED = 'NOT_GROUNDED'
}

export const groundedFilterMap = {
  [GroundedFilters.ALL]: undefined,
  [GroundedFilters.GROUNDED]: true,
  [GroundedFilters.NOT_GROUNDED]: false
};

// maps the different filter button groups to the correct dealer filter enum to be sent in the Sell Search Criteria
export const dealerFilterMap = {
  [OfferFilters.NONE]: undefined,
  [OfferFilters.OFFERS_BY_ANY_DEALER]: InventoryManagementDealerFilter.OFFERS_BY_ANY_DEALER,
  [OfferFilters.OFFERS_BY_DEALER]: InventoryManagementDealerFilter.OFFERS_BY_DEALER,
  [OfferFilters.DEALERS_WITH_COUNTER_OFFERS]: InventoryManagementDealerFilter.DEALERS_WITH_COUNTER_OFFERS,
  [QuestionFilters.NONE]: undefined,
  [QuestionFilters.QUESTIONS_BY_ANY_DEALER]: InventoryManagementDealerFilter.QUESTIONS_BY_ANY_DEALER,
  [QuestionFilters.QUESTIONS_BY_DEALER]: InventoryManagementDealerFilter.QUESTIONS_BY_DEALER,
  [BidsOffersFilters.ALL]: undefined,
  [BidsOffersFilters.WINNING_BIDS_OFFERS]: InventoryManagementDealerFilter.WON_BY_DEALER,
  [BidsOffersFilters.LOSING_BIDS_OFFERS]: InventoryManagementDealerFilter.BIDS_OFFERS_BY_DEALER
};

export enum ActionStatus {
  PENDING_SELLER_ACTION = 'PENDING_SELLER_ACTION',
  PENDING_BUYER_ACTION = 'PENDING_BUYER_ACTION',
  NO_ACTION = 'NO_ACTION',
  HOLD = 'HOLD',
  REMOVED = 'REMOVED',
  EXPIRED = 'EXPIRED'
}

export enum UpdateVehiclesActions {
  DEFAULT = 'default',
  DISCLOSURES_YELLOW_LIGHTS = 'DISCLOSURES_YELLOW_LIGHTS',
  VEHICLE_STATUS_CHANGE = 'VEHICLE_STATUS_CHANGE',
  MARK_ARRIVED = 'MARK_ARRIVED',
  RELEASE_PROCEEDS = 'RELEASE_PROCEEDS',
  REVERSE_RELEASE_PROCEEDS = 'REVERSE_RELEASE_PROCEEDS'
}

export enum AdminModalDisplay {
  FORM_TEMPLATE = 'formTemplate',
  RESULTS_TEMPLATE = 'resultsTemplate',
  ERROR_TEMPLATE = 'errorTemplate'
}

export enum VehicleStatusAction {
  ACTIVE = 'ACTIVE',
  HOLD = 'HOLD',
  REMOVE = 'REMOVED'
}

export enum GroundingAction {
  GROUND = 'GROUND',
  UNGROUND = 'UNGROUND'
}
